 import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NotificationApp } from "./NotificationApp";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { startGetHasPendingSurveys } from "../redux/slices/users/Surveys";
import Swal from "sweetalert2";
import {
    startAcceptPolicy,
    startGetPendingPolicy,
    startSetPolicy,
} from "@redux/actions/teachers/v2/cycles";
import ModalAppV2 from "./ModalAppV2";
import { Button, Modal } from "react-bootstrap";
import { SafeHtml } from "./SafeHtml";
import { IconApp } from "./IconApp";
import { CheckBoxApp } from "./CheckBoxApp";
import { SubjectByStudentApp } from "./SubjectByStudentApp";

const swalAlert = () =>
    Swal.fire({
        title: "<strong>Revisión de políticas requerida</strong>",
        html: `
            <p><strong>Estás accediendo a un nuevo ciclo escolar.</strong></p>
            <p>Debes revisar y aceptar las políticas institucionales para continuar.</p>
        `,
        icon: "warning",
        confirmButtonText: "Entendido",
        backdrop: true,
        padding: "2em",
    });

const PolicyForm = ({ policy, getPolicy, hasCourseLoad = false }) => {
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.auth);
    const [checked, setChecked] = useState(false);

    const handleAcceptPolicy = () => {
        dispatch(startAcceptPolicy(policy?.id, getPolicy));
    };

    const handleCheck = (e) => {
        const { value } = e.target;
        setChecked(value);
    };

    return (
        <>
            <Modal.Body className="py-0 pt-3 pb-3">
                <SafeHtml
                    html={policy?.cycle?.policy || ""}
                    className="ql-content"
                />
                {hasCourseLoad && (
                    <>
                        <h4 className="text-center border-top pt-3 pb-2 m-0 mt-4">
                            CARGA HORARIA
                        </h4>
                        <SubjectByStudentApp forceHideTeacher compact />
                    </>
                )}
            </Modal.Body>
            <Modal.Footer className="d-flex flex-column align-items-center">
                {!!policy?.cycle?.policy_document_uri && (
                    <a
                        href={policy?.cycle?.policy_document_uri}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-size-12 text-info text-decoration-underline"
                    >
                        Ver políticas completas
                    </a>
                )}
                <div className="my-3 d-flex flex-column align-items-center">
                    <div className="border-bottom padding-bottom-8 px-2">
                        <CheckBoxApp
                            className="custom-checkbox-app"
                            label={`Estoy enterado/a de las políticas${
                                hasCourseLoad ? " y carga horaria" : ""
                            } del ciclo`}
                            onChange={handleCheck}
                            labelClassName={"margin-top-2 text-size-12"}
                            checked={checked}
                        />
                    </div>
                    <p className="m-0 text-size-12 margin-top-2">
                        {user.full_name}
                    </p>
                </div>
                <Button
                    variant="primary"
                    className="btn-app-primary"
                    onClick={handleAcceptPolicy}
                    disabled={!checked}
                >
                    <IconApp iconClassName="fas fa-badge-check me-1" /> Aceptar
                </Button>
            </Modal.Footer>
        </>
    );
};

export const PendingPolicy = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();

    const { session } = useSelector((state) => state.auth);
    const { policy } = useSelector((state) => state.cycle);
    const { response } = useSelector((state) => state.subjectsByStudentApp);

    useEffect(() => {
        const pathname = location.pathname;
        const isInHomeModule = pathname.startsWith("/app/home");

        if (policy && !isInHomeModule) {
            navigate("/app/home");
        }
    }, [location]);

    const getPolicy = () => {
        if (session === "student") {
            dispatch(startGetPendingPolicy());
        }
    };

    return (
        <ModalAppV2
            titleModal={`POLÍTICAS ${
                !!response ? "Y CARGA HORARIA " : ""
            }DEL CICLO ${policy?.cycle?.year}-${policy?.cycle?.sub_cycle}`}
            size="xl"
            backdrop="static"
            keyboard={false}
            openModal={!!policy}
            Action={() => <></>}
            hiddenCloseButton
        >
            <PolicyForm
                policy={policy}
                getPolicy={getPolicy}
                hasCourseLoad={!!response}
            />
        </ModalAppV2>
    );
};
